export const APP_INSIGHTS_VIASSIST = {
  // [VA] = VIAssist
  GET_FILTERS: `[VA] GET FILTERS`,
  GET_FILTERS_SUCCESS: `[VA] GET FILTERS SUCCESS`,
  GET_FILTERS_ERROR: `[VA] GET FILTERS ERROR`,

  GET_SUGGESTIONS: `[VA] GET SUGGESTIONS`,
  GET_SUGGESTIONS_SUCCESS: `[VA] GET SUGGESTIONS SUCCESS`,
  GET_SUGGESTIONS_ERROR: `[VA] GET SUGGESTIONS ERROR`,

  SEARCH_FOR_DOCUMENTS: `[VA] SEARCH FOR DOCUMENTS`,
  SEARCH_FOR_DOCUMENTS_SUCCESS: `[VA] SEARCH FOR DOCUMENTS SUCCESS`,
  SEARCH_FOR_DOCUMENTS_ERROR: `[VA] SEARCH FOR DOCUMENTS ERROR`,

  GET_DOCUMENT: `[VA] GET DOCUMENT`,
  GET_DOCUMENT_SUCCESS: `[VA] GET DOCUMENT SUCCESS`,
  GET_DOCUMENT_ERROR: `[VA] GET DOCUMENT ERROR`,

  GET_DOCUMENT_DETAILS: `[VA] GET DOCUMENT DETAILS`,
  GET_DOCUMENT_DETAILS_SUCCESS: `[VA] GET DOCUMENT DETAILS SUCCESS`,
  GET_DOCUMENT_DETAILS_ERROR: `[VA] GET DOCUMENT DETAILS ERROR`,

  GET_DOCUMENT_IMAGES: `[VA] GET DOCUMENT IMAGES`,
  GET_DOCUMENT_IMAGES_SUCCESS: `[VA] GET DOCUMENT IMAGES SUCCESS`,
  GET_DOCUMENT_IMAGES_ERROR: `[VA] GET DOCUMENT IMAGES ERROR`,
  GET_DOCUMENT_IMAGES_CANCELED: `[VA] GET DOCUMENT IMAGES CANCELED`, //  request can reach server; however, it's cancelled by the browser
};
